import Component from "@ember/component"
import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import { objectId } from "@shared/util/object-id"
import createClassWebsiteAction from "cc-frontend/lib/actions/class-website/CREATE_CLASS_WEBSITE"
import type Dispatcher from "cc-frontend/services/dispatcher"

export default class SettingsWrapper extends Component {
  @service declare dispatcher: Dispatcher

  @action
  createNewClassWebsite() {
    get(this, "dispatcher").dispatchPreparedAction(
      createClassWebsiteAction({
        // @ts-ignore remove once we type the file
        planbookId: get(this, "planbook.id"),
        websiteId: objectId().toLowerCase(),
      })
    )
  }
}
